import { render, staticRenderFns } from "./Dropfile.vue?vue&type=template&id=46f10f89&scoped=true&"
import script from "./Dropfile.vue?vue&type=script&lang=js&"
export * from "./Dropfile.vue?vue&type=script&lang=js&"
import style0 from "./Dropfile.vue?vue&type=style&index=0&id=46f10f89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f10f89",
  null
  
)

export default component.exports